(function () {
  const TZ = 'Europe/Copenhagen';

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function tzOffsetMs(date, timeZone) {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23',
    }).formatToParts(date);
    const map = {};
    parts.forEach((part) => {
      if (part.type !== 'literal') map[part.type] = part.value;
    });
    const asUTC = Date.UTC(
      Number(map.year),
      Number(map.month) - 1,
      Number(map.day),
      Number(map.hour),
      Number(map.minute),
      Number(map.second)
    );
    return asUTC - date.getTime();
  }

  function zonedMidnightMs(ymd, timeZone) {
    const guess = Date.UTC(
      Number(ymd.slice(0, 4)),
      Number(ymd.slice(5, 7)) - 1,
      Number(ymd.slice(8, 10)),
      0,
      0,
      0
    );
    const first = new Date(guess - tzOffsetMs(new Date(guess), timeZone));
    return guess - tzOffsetMs(first, timeZone);
  }

  function exclusiveEndMs(ymd, timeZone) {
    const [year, month, day] = ymd.split('-').map(Number);
    const next = new Date(Date.UTC(year, month - 1, day + 1));
    const nextYmd = [next.getUTCFullYear(), pad(next.getUTCMonth() + 1), pad(next.getUTCDate())].join('-');
    return zonedMidnightMs(nextYmd, timeZone);
  }

  function setLabel(el, count) {
    if (!el || !el.dataset.one) return;
    el.textContent = count === 1 ? el.dataset.one : el.dataset.other;
  }

  class LiljaSaleEnd extends HTMLElement {
    connectedCallback() {
      const ymd = this.dataset.endDate;
      if (!ymd) return;
      this.endMs = exclusiveEndMs(ymd, this.dataset.timezone || TZ);
      this.root = this.closest('.lilja-sale-end');
      this.dayEl = this.querySelector('[data-unit="days"]');
      this.hourEl = this.querySelector('[data-unit="hours"]');
      this.minEl = this.querySelector('[data-unit="minutes"]');
      this.dayWrap = this.querySelector('[data-unit-wrap="days"]');
      this.daySep = this.querySelector('[data-sep="days"]');
      this.dayLabel = this.querySelector('[data-label="days"]');
      this.hourLabel = this.querySelector('[data-label="hours"]');
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    tick() {
      const diff = this.endMs - Date.now();
      if (diff <= 0) {
        if (this.root) this.root.hidden = true;
        clearInterval(this.timer);
        return;
      }

      const totalMin = Math.floor(diff / 60000);
      const days = Math.floor(totalMin / 1440);
      const hours = Math.floor((totalMin % 1440) / 60);
      const mins = totalMin % 60;
      const stamp = `${days}:${hours}:${mins}`;
      if (stamp === this.lastStamp) return;
      this.lastStamp = stamp;

      if (this.dayWrap) this.dayWrap.hidden = days <= 0;
      if (this.daySep) this.daySep.hidden = days <= 0;
      if (this.dayEl) this.dayEl.textContent = String(days);
      if (this.hourEl) this.hourEl.textContent = String(hours);
      if (this.minEl) this.minEl.textContent = String(mins);
      setLabel(this.dayLabel, days);
      setLabel(this.hourLabel, hours);
    }
  }

  if (!customElements.get('lilja-sale-end')) {
    customElements.define('lilja-sale-end', LiljaSaleEnd);
  }
})();
